"use client";
import React from "react";

interface IDynamicStylesProps {
  styles: any[];
  globalStyles?: string[];
}

function getStyles(styles?: string[], globalStyles?: string[]): JSX.Element {
  const styleTags: string[] =
    styles && Array.isArray(styles) ?
      globalStyles.concat(styles) :
      [].concat(globalStyles);
  const allStyleTags: string[] = styleTags;
  let content = ``;
  for (const style of allStyleTags) {
    if (style) {
      content += style;
    }
  }
  return (
    content && (
      <React.Fragment key={`headStyle`}>
        <style>{content}</style>
      </React.Fragment>
    )
  );
}

export function DynamicStyles(props: IDynamicStylesProps) {
  const stylesTag = getStyles(props?.styles, props?.globalStyles);

  return <>{stylesTag}</>;
}

export default DynamicStyles;
